export default __webpack_public_path__ + "static/media/modal-header-icon.dc3bd0b6.svg";